export default __webpack_public_path__ + "static/reed-1--mobile-5b0ea3f6bec2193420ae3d2850bcc87c.jpg";